var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "breadcrumb" }, [_c("navbar")], 1),
      _c("div", { staticClass: "content page-title" }, [
        _c("h2", [_vm._v(_vm._s(_vm.pageTitle))]),
      ]),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h4", [_vm._v("基础信息")]),
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "details-form",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "分享路径", prop: "path" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择分享路径" },
                      model: {
                        value: _vm.ruleForm.path,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "path", $$v)
                        },
                        expression: "ruleForm.path",
                      },
                    },
                    _vm._l(_vm.dictionaries.share_config_path, function (item) {
                      return _c("el-option", {
                        key: item.dictId,
                        attrs: { label: item.dictName, value: item.dictId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "分享平台", prop: "platformId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "请选择分享平台" },
                      model: {
                        value: _vm.ruleForm.platformId,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "platformId", $$v)
                        },
                        expression: "ruleForm.platformId",
                      },
                    },
                    _vm._l(_vm.platformList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "分享终端", prop: "platform" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择分享终端" },
                      model: {
                        value: _vm.ruleForm.platform,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "platform", $$v)
                        },
                        expression: "ruleForm.platform",
                      },
                    },
                    _vm._l(
                      _vm.dictionaries.share_config_platform,
                      function (item) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: { label: item.dictName, value: item.dictId },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "分享链接", prop: "url" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入对应的跳转链接" },
                    model: {
                      value: _vm.ruleForm.url,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "url", $$v)
                      },
                      expression: "ruleForm.url",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "分享图片", prop: "img" } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticClass: "avatar-uploader",
                      attrs: {
                        action: "",
                        accept: "image/*",
                        "http-request": _vm.uploadFile,
                        "auto-upload": true,
                        "show-file-list": false,
                        "before-upload": _vm.beforeAvatarUpload,
                      },
                    },
                    [
                      _vm.ruleForm.img
                        ? _c("img", {
                            staticClass: "avatar",
                            attrs: { src: _vm.ruleForm.img },
                          })
                        : _c("i", {
                            staticClass: "el-icon-plus avatar-uploader-icon",
                          }),
                    ]
                  ),
                  _c("p", [_vm._v("2M以内")]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "分享标题", prop: "title" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "文案最多可以输入14个字，请留意",
                      maxlength: "14",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.ruleForm.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "title", $$v)
                      },
                      expression: "ruleForm.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "分享文案", prop: "content" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "文案最多可以输入20个字，请留意",
                      maxlength: "20",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.ruleForm.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "content", $$v)
                      },
                      expression: "ruleForm.content",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "operation-button" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("cancel")
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "warning" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("preview")
                        },
                      },
                    },
                    [_vm._v("预览")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("save")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "append-to-body": true,
            "custom-class":
              _vm.dialog.type === "modifyState" ? "modify-state" : "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          [_c("preview", { attrs: { previewObj: _vm.preview } })],
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitDialog } },
                [_vm._v("返回")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }